import api from '@/api/referral';

export default {
  namespaced: true,
  state: () => ({
    items: null,
  }),
  getters: {
    referrals(state) {
      return (state.items ?? []).map(r => ({
        ...r.referral,
        createdAt: new Date(r.referral.createdAt),
        paymentsSum: (r.referral.payments ?? [])
          .filter(p => p.status === 'confirmed')
          .reduce((acc, val) => val.amount + acc, 0),
        status: r.referral.accountBlocked ? 'blocked' : (r.referral.accountConfirmed ? 'active' : 'notConfirmed'), // eslint-disable-line no-nested-ternary
      }));
    },
    transactions(state) {
      return (state.items ?? [])
        .reduce(
          (acc, val) => [
            ...acc,
            ...val.referral.payments
              .filter(p => p.status === 'confirmed')
              .map(
                p => ({
                  ...p,
                  createdAt: new Date(p.createdAt),
                  user: { ...val.referral, payments: null },
                }),
              ),
          ],
          [],
        )
        .sort((a, b) => b.createdAt - a.createdAt);
    },
  },
  mutations: {
    setReferrals(state, items) { state.items = items; },
  },
  actions: {
    fetch({ state, commit }) {
      if (state.items) {
        return;
      }

      api.fetchList([], true)
        .then((r) => { commit('setReferrals', r.items); });
    },
  },
};
